// extracted by mini-css-extract-plugin
export default {"flexContainer":"MiddleMain_flexContainer__rDe6B"};